import { render, staticRenderFns } from "./AppMfe.vue?vue&type=template&id=485cb468&scoped=true"
import script from "./AppMfe.vue?vue&type=script&lang=js"
export * from "./AppMfe.vue?vue&type=script&lang=js"
import style0 from "./AppMfe.vue?vue&type=style&index=0&id=485cb468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cb468",
  null
  
)

export default component.exports